
import Footer from '../components/footer.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


import {
SaunaKanbanQuery,
Magician,
GetLeftUpInfo
} from '../../static/js/api.js'
import querystring from 'vux/src/tools/querystring/index.js'

function loadtotal(that) {

GetLeftUpInfo({}, function (res) {
console.log(res)
if (res.data.state==1) {

that.my = res.data.doc


console.log(that.my)
} else {

that.$vux.toast.text('您不是员工，请管理员录入', 'middle')

}


})

SaunaKanbanQuery({}, function (res) {
console.log(res)
if (res.data.IsSuccess) {

that.data = JSON.parse(res.data.Result)
that.loading=false
that.end_at= res.data.end_at.substr(0,10)

that.fukuan = res.data.fukuan? res.data.fukuan.split("，") : []
console.log(that.fukuan)

console.log('======')

console.log(that.data)

var arr = JSON.parse(res.data.Result).PayModeDetails
let tempArr = [], newArrs = []
for (let i = 0; i < arr.length; i++) {
if (tempArr.indexOf(arr[i].GroupName) === -1) {
newArrs.push({
GroupName: arr[i].GroupName,
list: [arr[i]]
})
tempArr.push(arr[i].GroupName);
} else {
for (let j = 0; j < newArrs.length; j++) {
if (newArrs[j].GroupName == arr[i].GroupName) {
newArrs[j].list.push(arr[i])
}
}
}
}
console.log(newArrs)
var selectArr = []
if(that.fukuan.length!=0){



for(var j = 0 ;j<newArrs.length;j++){
for(var i=0;i<that.fukuan.length;i++){
var item  = that.fukuan[i]
if(item == newArrs[j].GroupName){
var totalNum = 0;
for(var m=0;m<newArrs[j].list.length;m++){
totalNum += newArrs[j].list[m].Money
}
newArrs[j].total = totalNum.toFixed(2);
selectArr.push(newArrs[j]);
break
}

}

}
}else{
for(var j = 0 ;j<newArrs.length;j++){

var totalNum = 0;
for(var m=0;m<newArrs[j].list.length;m++){
totalNum += newArrs[j].list[m].Money
}
newArrs[j].total = totalNum.toFixed(2);

selectArr.push(newArrs[j])
}

}


console.log(selectArr);

that.forArr = selectArr


var data= new Date();
var s1 = that.end_at
var s2 = formatDate(data).substr(0,10)
that.leaveDay = minusDate(s2,s1)

if(that.leaveDay>0&&that.leaveDay<8){
that.alert= true
}

if(that.leaveDay<=0){
that.alert1= true
}


console.log(that.data)
} else {

that.$vux.toast.text('数据获取失败，请重试', 'middle')

}


})

}




function minusDate(s1,s2){

s1 = new Date(s1.replace(/-/g, "/"));
s2 = new Date(s2.replace(/-/g, "/"));
var days = s2.getTime() - s1.getTime();
var time = parseInt(days / (1000 * 60 * 60 * 24));
return time;
}

function formatDate(time,zh=false) {
var date = new Date(time);
var year = date.getFullYear();
/* 在日期格式中，月份是从0开始的，因此要加0
* 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
* */
var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

if(zh){
return year + "年" + month + "月" + day + "日";

}else{
return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;

}
}


export default {
name: 'app',
components: {
'pc-footer': Footer,
},
directives: {
TransferDom
},
data() {
return {
show3:false,
alert1:false,
alert:false,
loading:true,
end_at:'2020-05-01',
leaveDay:0,
my:{
name:"***",
company:{
name:"***"
}
},
fukuan:[],
forArr: [],
data: {
GuestFlows: {},
BarConsumeDetails: {},
BarConsumeSummary: {},
ConsumeDetails: {},
ConsumeSummary: {},
GuestPerConsume: {},
HandCardUsed: {},
MemberUsedDetail: {},
MemberUsedSummary: {},
NewMemberDetails: {},
NewMemberSummary: {},
PayModeDetails: {},
PayModeSummary: {
Money:1
},
PrepaidMemberDetails: {},
PrepaidMemberSummary: {},


},
msg: 'Welcome to Your Vue.js App',
nav: [
{
link:'/yingyun',
name:'当前营业',
img:require('../assets/CRM_icon_dqyy.png'),

},
{
link:'/jiaoban',
name:'已交班',
img:require('../assets/CRM_icon_yjb.png'),

},
{
link:'/yichang',
name:'异常报表',
img:require('../assets/CRM_icon_ycbb.png'),

},
{
link:'/hjyingyun',
name:'会籍营业',
img:require('../assets/CRM_icon_hjyy.png'),

},
{
link:'/hjjiaoban',
name:'会籍交班',
img:require('../assets/CRM_icon_kjjb.png'),

},
{
link:'/hjyichang',
name:'会员卡套现',
img:require('../assets/CRM_icon_hyktx.png'),

},
{
link:'/hjyichangcard',
name:'会员卡消费',
img:require('../assets/CRM_icon_hykxf.png'),

},
{
link:'/hjyichangzhuan',
name:'会员卡转账',
img:require('../assets/CRM_icon_hykzz.png'),

}

],
selectedsr:1,
navsr:[

{
id:1,
name:"会员办卡"

},
{
id:2,
name:"会员续费"

}

]
}
},
computed:{


people(){
var people=0;
for(var i=0;i<this.data.GuestInfos.length;i++){
var item=this.data.GuestInfos[i]
people+=item.Comein

}
people = people.toFixed(0)

return people
}


},
mounted(){



},
created() {

var that = this
loadtotal(that)


},
methods:{
clear(){
this.show3=true


},
onConfirm(e){
var that=this
Magician({code:e}, function (res) {
console.log(res)
if (res.data.IsSuccess) {


that.$vux.toast.text('清理数据成功', 'middle')
} else {

that.$vux.toast.text(res.data.ErrorMsg, 'middle')

}


})
},

refresh(){
this.loading=true
var that=this
loadtotal(that)


},

changesr(index){
console.log(index)
this.selectedsr= parseInt(index+1)

}




}

}



// WEBPACK FOOTER //
// ./src/pages/main.vue